import { format, parseISO } from 'date-fns'

import { formatCurrency } from '../../../utils/format-helpers'

import type { LoyaltyBonusRule } from '../../loyalty.schema'
import { ruleStates } from '../../../constants/misc'

type Status = Record<typeof ruleStates[number], string>
const statusClasses: Status = {
  active: 'text-green-300',
  draft: 'text-slate-300',
  stopped: 'text-red-500',
}

type Props = { bonusRule: LoyaltyBonusRule }

function BonusRule({ bonusRule }: Props) {
  const { endDate, expirationPointsDays, startDate, text, value } = bonusRule

  return (
    <>
      <div>
        {/* Bonus Status */}
        <div className="flex items-center gap-x-1">
          <h2 className="text-lg">Bonus: </h2>
          <span className={statusClasses[bonusRule.state]}>
            {bonusRule.state}
          </span>
        </div>
        {/* Bonus text or value */}
        <div>
          {text ? (
            <p>{text}</p>
          ) : value ? (
            <p>{formatCurrency(value)} in rewards</p>
          ) : (
            <p>There is no bonus to display.</p>
          )}
        </div>
        {/* Bonus window */}
        <div>
          {startDate ? (
            <p>
              <span className="font-semibold">Start Date: </span>
              {format(parseISO(startDate), 'MMM dd, yyyy')}
            </p>
          ) : null}
          {endDate ? (
            <p>
              <span className="font-semibold">End Date: </span>
              {format(parseISO(endDate), 'MMM dd, yyyy')}
            </p>
          ) : null}
          {expirationPointsDays ? (
            <p>
              Expires{' '}
              <span className="font-semibold">{expirationPointsDays} days</span>{' '}
              after message sent
            </p>
          ) : null}
        </div>
      </div>
    </>
  )
}

export { BonusRule }
